import { useReveal } from "./hooks/useReveal.js";
import { Nav } from "./sections/Nav.jsx";
import { Hero } from "./sections/Hero.jsx";
import { Dock } from "./sections/Dock.jsx";
import { Problem } from "./sections/Problem.jsx";
import { WhatWeDo } from "./sections/WhatWeDo.jsx";
import { HowItWorks } from "./sections/HowItWorks.jsx";
import { Vision } from "./sections/Vision.jsx";
import { Verticals } from "./sections/Verticals.jsx";
import { Stack } from "./sections/Stack.jsx";
import { Team } from "./sections/Team.jsx";
import { Waitlist } from "./sections/Waitlist.jsx";
import { Footer } from "./sections/Footer.jsx";

const SHOW_TEAM = false;

export function App() {
  const { useState } = React;
  useReveal();
  const [activeIndustry, setActiveIndustry] = useState(0);
  // The vertical sent with a waitlist entry reflects a deliberate choice, not the default tab.
  const [industryChosen, setIndustryChosen] = useState(false);
  const chooseIndustry = (i) => {
    setActiveIndustry(i);
    setIndustryChosen(true);
  };

  return (
    <>
      <Nav />
      <Hero activeIndustry={activeIndustry} onChangeIndustry={chooseIndustry} />
      <Dock activeIndustry={activeIndustry} onChangeIndustry={chooseIndustry} />
      <Problem activeIndustry={activeIndustry} />
      <WhatWeDo activeIndustry={activeIndustry} />
      <HowItWorks />
      <Vision />
      <Verticals />
      <Stack activeIndustry={activeIndustry} />
      {SHOW_TEAM && <Team />}
      <Waitlist activeIndustry={industryChosen ? activeIndustry : null} />
      <Footer />
    </>
  );
}
